import clsx from "clsx";

import { Card } from "../../../../shared/card/card.tsx";
import { Select } from "../../../../ui/index.ts";
import type { SelectOption } from "../../../../ui/index.ts";

import type { Period, PeriodRange } from "../../types.ts";
import { PeriodRangeControl } from "../period-range-control/period-range-control.tsx";
import { PeriodSelector } from "../period-selector/period-selector.tsx";

import styles from "./overview-toolbar.module.css";

export interface OverviewToolbarProps {
  employeeId: string;
  onEmployeeIdChange: (id: string) => void;
  employeeOptions: SelectOption[];
  employeesLoading: boolean;
  employeesError: string | null;
  period: Period;
  onPeriodChange: (period: Period) => void;
  range: PeriodRange;
  onRangeChange: (range: PeriodRange) => void;
}

export function OverviewToolbar({
  employeeId,
  onEmployeeIdChange,
  employeeOptions,
  employeesLoading,
  employeesError,
  period,
  onPeriodChange,
  range,
  onRangeChange,
}: OverviewToolbarProps) {
  return (
    <Card padding="3xl" className={styles.card}>
      <div className={styles.grid}>
        <div className={styles.fieldEmployee}>
          <Select
            label="Employee Name"
            placeholder={employeesLoading ? "Loading…" : "Select Employee Name"}
            searchable
            isClearable
            disabled={employeesLoading}
            value={employeeId}
            onChange={onEmployeeIdChange}
            options={employeeOptions}
          />
        </div>
        <div className={styles.fieldPeriod}>
          <span className={clsx("sub-heading-md", styles.periodLabel)}>
            View By
          </span>
          <PeriodSelector
            value={period}
            onChange={onPeriodChange}
            disabled={employeesLoading}
          />
        </div>
        <div className={styles.fieldRange}>
          <PeriodRangeControl
            period={period}
            range={range}
            onChange={onRangeChange}
            disabled={employeesLoading}
          />
        </div>
      </div>
      {employeesError ? (
        <p className={styles.error} role="alert">
          {employeesError}
        </p>
      ) : null}
    </Card>
  );
}
